// import axios from "axios";


// export default {
//   get: async (URL) => axios.get(URL),
//   delete: async (URL) => axios.delete(URL),
//   post: async (URL, DATA) => axios.post(URL, DATA),
  
//   getWithToken: async (URL) =>
//     axios.get(URL, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     }),
    
//   deleteWithToken: async (URL) =>
//     axios.delete(URL, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     }),
//   postWithToken: async (URL, DATA) =>
//     axios.post(URL, DATA, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     }),
    
//     putWithToken: async (URL, DATA) =>
//     axios.put(URL, DATA, {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     }),   
// };


// check for token error 

import axios from "axios";


const axiosInstance = axios.create();

const getAuthorizationHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    const headers = error.config?.headers;
    const authorization =
      typeof headers?.get === "function"
        ? headers.get("Authorization")
        : headers?.Authorization;
    const wasAuthenticatedRequest =
      Boolean(authorization) &&
      authorization !== "Bearer null" &&
      authorization !== "Bearer undefined";

    // Public browsing endpoints can legitimately reject a request without
    // meaning the visitor's session expired. Only force login when the failed
    // request actually carried the user's token.
    if (error.response?.status === 403 && wasAuthenticatedRequest) {
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      localStorage.removeItem('user');
      localStorage.removeItem('profile_image');
      window.location.href = "/login";
      // Depending on how your app is structured, you may need to replace
      // the above line with history.push('/login') or similar.
    }
    return Promise.reject(error);
  }
);

export default {
  get: async (URL) => axiosInstance.get(URL),
  delete: async (URL) => axiosInstance.delete(URL),
  post: async (URL, DATA) => axiosInstance.post(URL, DATA),
  
  getWithToken: async (URL) =>
    axiosInstance.get(URL, {
      headers: getAuthorizationHeaders(),
    }),
    
  deleteWithToken: async (URL) =>
    axiosInstance.delete(URL, {
      headers: getAuthorizationHeaders(),
    }),
  postWithToken: async (URL, DATA) =>
    axiosInstance.post(URL, DATA, {
      headers: getAuthorizationHeaders(),
    }),
    
  putWithToken: async (URL, DATA) =>
    axiosInstance.put(URL, DATA, {
      headers: getAuthorizationHeaders(),
    }),   
};
